/* eslint-disable */
import { CircularProgress, Divider, List, ListItem } from "@material-ui/core";
import React, { useEffect, useState, useMemo } from "react";
import { useLocation, withRouter } from "react-router-dom";
import { clearIntervalAsync } from "set-interval-async";
import { setIntervalAsync } from "set-interval-async/dynamic";
import SmallEtaCard from "../../components/SmallEtaCard";
import Constants from "../../utils/constants";
import { getRouteStopEta } from "../../utils/api";
import "./styles.scss";
import { langStringConvertor } from "../../utils/utils";

const { LANGUAGES } = Constants;
const { appTitle, routesTitle } = LANGUAGES;

const Home = (props) => {
  const {
    routes,
    routeIds,
    lang,
    site,
    court,
    redirect,
    displayType,
    setCurrentTitle,
    displayRouteCode,
    firstStopEtaRoutes,
    fakeCircularRoutes,
    overrideDepartureTimeRoutes,
    themeColour,
    showLicensePlate
  } = props;
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [etas, setEtas] = useState([]);
  const [preEtas, setPreEtas] = useState([]);
  const [vehicleLocations, setVehicleLocations] = useState(null);

  const getEta = async () => {
    await Promise.all(
      routes.map(async (route, index) => {
        return Promise.all(
          route.routeStops.map(async (direction, index) => {
            const tempResult = await getRouteStopEta(
              route.route_id,
              route.directions[index].route_seq
            );
            setVehicleLocations({...vehicleLocations, ...tempResult.vehicleLocation});

            let finalResult = null;

            /**
             * handle firstStopEtaRoutes
             */
            if (
              firstStopEtaRoutes &&
              firstStopEtaRoutes.length > 0 &&
              firstStopEtaRoutes.includes(parseInt(route.route_id, 10))
            ) {
              finalResult = { ...tempResult };
              const oppoEta = await getRouteStopEta(
                route.route_id,
                parseInt(route.directions[index].route_seq, 10) === 1 ? 2 : 1
              );
              if (tempResult && oppoEta?.eta.length > 0) {
                finalResult.eta = tempResult?.eta.map((el, indexx) => {
                  if (indexx === 0) {
                    el?.eta.push(oppoEta.eta[oppoEta.eta.length - 1].eta[0]);
                    el?.eta.sort((a, b) => (a.diff < b.diff ? -1 : 1));
                    const temp = el.eta.map((ele, indexxx) => ({
                      ...ele,
                      eta_seq: indexxx + 1,
                    }));
                    el.eta = temp;
                  }
                  return el;
                });
              }
            }
            if (
              overrideDepartureTimeRoutes &&
              overrideDepartureTimeRoutes.length > 0 &&
              overrideDepartureTimeRoutes.includes(parseInt(route.route_id, 10))
            ) {
              finalResult = { ...tempResult, needCheckTime: true };
            }
            return finalResult || tempResult;
          })
        );
      })
    ).then((result) => {
      overrideDepartureTimeRoutes && overrideDepartureTimeRoutes.length > 0
        ? setPreEtas(result)
        : setEtas(result);

      // console.log(result);
    });
  };

  useEffect(() => {
    if (preEtas && preEtas.length > 0) {
      const newEta = preEtas.map((routes) => {
        return routes.map((directions, index) => {
          if (directions.needCheckTime) {
            // console.log("check Another Route time");
            const firstStationFirstTime = directions?.eta?.[0]?.eta?.[0];
            const otherBoundlastStationFirstTime =
              index === 0
                ? routes?.[1]?.eta?.[routes[1].eta.length - 1]?.eta?.[0]
                : routes?.[0]?.eta?.[routes[0].eta.length - 1]?.eta?.[0];
            if (otherBoundlastStationFirstTime?.vehicle) {
              if (
                otherBoundlastStationFirstTime?.diff >
                firstStationFirstTime?.diff
                // true
              ) {
                directions.eta[0].eta[0] = otherBoundlastStationFirstTime;
              }
            }
          }
          return directions;
        });
      });
      // console.log("newEta====", newEta);
      setEtas(newEta);
    }
  }, [preEtas]);

  useEffect(() => {
    if (routes && routes.length > 0) {
      // console.log(routes);
      if (isFirstTime) {
        getEta();
        setIsFirstTime(false);
      }
      const timer = setIntervalAsync(async () => {
        await getEta();
      }, 10000);

      return () => {
        clearIntervalAsync(timer);
      };
    }
  }, [routes]);

  useEffect(() => {
    if (lang) {
      setIsLoading(false);
      setCurrentTitle(null);
    }
  }, [lang]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="progress-container"
        >
          <CircularProgress color="primary" />
        </div>
      ) : (
        <List component="nav" style={{ height: "100%", overflow: "auto" }}>
          {routes.map((route, ind) =>
            route &&
            route.directions.length > 0 &&
            route.routeStops &&
            route.routeStops.length > 0
              ? route.directions
                  .sort((a, b) =>
                    `${a.route_seq}` > `${b.route_seq}` ? 1 : -1
                  )
                  .map((origin, index) => {
                    /**
                     * combine stops / fake circular routes
                     */
                    if (
                      displayType === "combineStops" ||
                      (fakeCircularRoutes &&
                        fakeCircularRoutes.includes(route.route_id))
                    ) {
                      if (origin.route_seq > 1) {
                        return (
                          <React.Fragment
                            key={`${route.route_id}${origin.route_seq}`}
                          ></React.Fragment>
                        );
                      } else {
                        const anotherLastEta = {
                          ...etas?.[ind]?.[index + 1].eta[
                            etas?.[ind]?.[index + 1].eta.length - 1
                          ],
                          stopSeq: route.routeStops[index].length + 1,
                        };
                        return (
                          <React.Fragment
                            key={`${route.route_id}${origin.route_seq}`}
                          >
                            <ListItem button>
                              <SmallEtaCard
                                key={`${
                                  origin[`orig_${langStringConvertor(lang)}`]
                                }${
                                  origin[`dest_${langStringConvertor(lang)}`]
                                }`}
                                origin={
                                  origin[`orig_${langStringConvertor(lang)}`]
                                }
                                destination={
                                  origin[`dest_${langStringConvertor(lang)}`]
                                }
                                stations={[
                                  ...route.routeStops[index],
                                  route.routeStops[index + 1][
                                    route.routeStops[index + 1].length - 1
                                  ],
                                ]}
                                redirect={() => {
                                  redirect(route.route_id, origin.route_seq);
                                }}
                                eta={
                                  etas.length > 0
                                    ? {
                                        ...etas?.[ind]?.[index],
                                        eta: [
                                          ...etas?.[ind]?.[index].eta,
                                          anotherLastEta,
                                        ],
                                      }
                                    : etas?.[ind]?.[index]
                                }
                                language={lang}
                                displayType={"combineStops"}
                                court={court}
                                routeCode={
                                  displayRouteCode
                                    ? `${route["route_code"]}: `
                                    : null
                                }
                                themeColour={themeColour}
                                showLicensePlate={showLicensePlate}
                                vehicleLocations={vehicleLocations}
                              />
                            </ListItem>
                            <Divider />
                          </React.Fragment>
                        );
                      }
                    }
                    /**
                     * normal cases
                     */
                    return (
                      <React.Fragment
                        key={`${route.route_id}${origin.route_seq}`}
                      >
                        <ListItem button>
                          <SmallEtaCard
                            key={`${
                              origin[`orig_${langStringConvertor(lang)}`]
                            }${origin[`dest_${langStringConvertor(lang)}`]}`}
                            origin={origin[`orig_${langStringConvertor(lang)}`]}
                            destination={
                              origin[`dest_${langStringConvertor(lang)}`]
                            }
                            stations={route.routeStops[index]}
                            redirect={() => {
                              redirect(route.route_id, origin.route_seq);
                            }}
                            eta={etas?.[ind]?.[index]}
                            language={lang}
                            displayType={displayType}
                            court={court}
                            routeCode={
                              displayRouteCode
                                ? `${route["route_code"]}: `
                                : null
                            }
                            color={origin?.eta_app_color}
                            themeColour={themeColour}
                            showLicensePlate={showLicensePlate}
                            vehicleLocations={vehicleLocations}
                          />
                        </ListItem>
                        <Divider />
                      </React.Fragment>
                    );
                  })
              : null
          )}
        </List>
      )}
    </>
  );
};

export default withRouter(Home);
